import classNames from 'classnames';
import React from 'react';
import { useDrop } from 'react-dnd';
import useDragDropRef from '../../utils/useDragDropRef';
import type { ContentMapDropParams } from '../utils/types';
import * as styles from './TopicTreeCardDropSeparator.module.scss';

type TopicTreeCardDropSeparatorProps = ContentMapDropParams;

const TopicTreeCardDropSeparator = (
  dropParams: TopicTreeCardDropSeparatorProps,
) => {
  const [{ isOver, isDragging }, originalDropRef] = useDrop(dropParams);
  const dropRef = useDragDropRef(originalDropRef);

  return (
    <div className={styles.container}>
      {isOver && <div className={styles.overIndicator} />}
      <div
        ref={dropRef}
        className={classNames(styles.drop, {
          [styles.isDragging]: isDragging,
        })}
      />
    </div>
  );
};

export default TopicTreeCardDropSeparator;
